import { getDomianSelect, getBrandSelect, getCourseSelect,getSecondProductSelect } from '@/service/area'
const role = {
  namespaced: true, 
  state: {
    domianList: [],
    secondProductList: [],
    brandList: [],
    courseList: [],
  },
  mutations: {
    SET_DOMIAN_LIST: (state, list) => {
      state.domianList = list
    },
    SET_Second_Product_LIST: (state, list) => {
      state.secondProductList = list
    },
    SET_BRAND_LIST: (state, list) => {
      state.brandList = list
    },
    SET_COURSE_LIST: (state, list) => {
      state.courseList = list
    }
  },
  actions: {
    getDomianList({ commit }) {
      getDomianSelect().then(res=>{
        res.Result === 1 && commit('SET_DOMIAN_LIST', res.Data)
      })
    },
    getSecondProductList({ commit }) {
      console.log('执行 getSecondProductList')
      getSecondProductSelect().then(res=>{
        res.Result === 1 && commit('SET_Second_Product_LIST', res.Data)
      })
    },	
    getBrandList({ commit }) {
      getBrandSelect().then(res=> {
        if(res.Result === 1) {
          res.Data.map(item=>{
            item.key = Number(item.key)
            return item;
          })
          commit('SET_BRAND_LIST', res.Data)
        }
      })
    },
    getCourseList({ commit }) {
      getCourseSelect().then(res=> {
        res.Result === 1 && commit('SET_COURSE_LIST', res.Data)
      })
    },
  }
}

export default role
